/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import userSlice from '../user';

/**
 * @deprecated Migration-only. Runtime tour state lives in `redux/slices/tours`.
 * Kept so redux-persist can rehydrate older clients' `guidedTour` keys; `TourLegacyMigration`
 * folds that into `tours` after session check and then clears this slice.
 *
 * TODO(sc-6875): Remove after one release with TourLegacyMigration.
 */
export interface GuidedTourState {
  isActive: boolean;
  isPaused: boolean;
  stepHistory: string[];
  isCompleted: boolean;
  bannerFirstShownAt?: number;
  furthestStepIndex: number;
  furthestStepId?: string;
  userId?: string;
  mobileWarningDismissed?: boolean;
}

const initialState: GuidedTourState = {
  isActive: false,
  isPaused: false,
  stepHistory: [],
  isCompleted: false,
  furthestStepIndex: -1,
  mobileWarningDismissed: false,
};

const guidedTourSlice = createSlice({
  name: 'guidedTour',
  initialState,
  reducers: {
    /** Wipe after a successful migration (or when the legacy owner is not the current user). */
    clearLegacyGuidedTour: () => initialState,
  },
  extraReducers: (builder) => {
    // Logout must not leave another account's history on disk for the next rehydrate.
    builder.addCase(userSlice.actions.unsetUserData, () => initialState);
  },
});

export default guidedTourSlice;
